export default "__VITE_ASSET__DyzO9qBj__"